<template>
  <form @submit.prevent="submitForm">
    <h2 :class="style['user-title']">
      {{ $t('sign_up') }}
    </h2>
    <figure role="group">
      <p :class="style['chat-message']">
        {{ $t('new_user.information') }}<br />
        {{ $t('new_user.information2') }}
      </p>
      <figure-caption-user :settings="settings" />
    </figure>

    <label for="name" :class="style['user-label']">
      <input
        id="name"
        v-model="inputName"
        type="text"
        autofocus
        placeholder=" "
        :class="style['user-input']"
        @input="resetErrorMessages()"
      />
      <span :class="style['field-name']">
        {{ $t('new_user.name_placeholder') }}
      </span>
    </label>

    <label for="email" :class="style['user-label']">
      <input
        id="email"
        v-model="inputEmail"
        type="email"
        placeholder=" "
        :class="style['user-input']"
        @input="resetErrorMessages()"
      />
      <span :class="style['field-name']">{{ $t('new_user.email_placeholder') }}</span>
    </label>

    <p :class="style['form-text']">
      {{ $t('user_top.terms_and_condition.before') }}
      <a :href="termsAndConditionURL" target="_blank">
        {{ $t('user_top.terms_and_condition.link') }}
      </a>
      &nbsp;{{ $t('user_top.terms_and_condition.and') }}&nbsp;
      <a :href="privacyPolicyLink" target="_blank">
        {{ $t('user_top.terms_and_condition.privacy_policy') }}
      </a>
      {{ $t('user_top.terms_and_condition.after') }}
    </p>

    <p :class="style[errorMessage.cssClass]">
      {{ errorMessage.message }}
      {{ errorMessage.before }}
      <a v-if="errorMessage.linkText !== ''" href="#" @click.prevent="goToUserComponent('SignIn')">
        {{ errorMessage.linkText }}
      </a>
      {{ errorMessage.after }}
    </p>

    <input
      type="submit"
      :class="[style['user-input'], style['submit-button']]"
      :value="$t('sign_up')"
      :disabled="isSending"
    />

    <p :class="style['t-r']">
      {{ $t('user_top.or') }}&nbsp;
      <a href="#" @click.prevent="goToUserComponent('SignIn')">
        {{ $t('sign_in') }}
      </a>
    </p>
  </form>
</template>

<script>
import { User } from 'src/apis'
import { termsAndConditionURL, privacyPolicyURLForJA, privacyPolicyURL } from 'javascript/Constants'
import FigureCaptionUser from './FigureCaptionUser.vue'
import style from './scss/_users.scss'
import { useUserStore } from 'Store/user'
import { useSettingsStore } from 'Store/settings'

export default {
  components: {
    FigureCaptionUser
  },
  props: {
    settings: { type: Object, required: true },
    goToUserComponent: { type: Function, required: true }
  },

  setup() {
    const userStore = useUserStore()
    const settingsStore = useSettingsStore()

    return { userStore, settingsStore }
  },

  data: function () {
    return {
      inputName: '',
      inputEmail: '',
      errorMessage: {
        cssClass: 'error-text',
        message: '',
        linkText: '',
        before: '',
        after: ''
      },
      style,
      termsAndConditionURL,
      isSending: false
    }
  },
  computed: {
    privacyPolicyLink() {
      return this.$i18n.locale === 'ja' ? privacyPolicyURLForJA : privacyPolicyURL
    }
  },
  methods: {
    submitForm() {
      this.isSending = true
      User.SignUpKnownUser(this.inputName, this.inputEmail, this.settingsStore.getHotelId)
        .then((json) => {
          this.isSending = false
          this.errorMessage.cssClass = 'form-text'
          this.formatMessageWithLink(this.$t('new_user.email_sent'))
          this.userStore.setUser(json.data.user.known_user)
        })
        .catch((error) => {
          this.isSending = false
          if (error.hasOwnProperty('xhr') && error.xhr.status === 406) {
            this.errorMessage.cssClass = 'error-text'
            this.errorMessage.message = this.$t('new_user.error_message.email')
          } else {
            this.errorMessage.message = this.$t('new_user.error_message.problem')
          }
        })
    },
    resetErrorMessages() {
      this.errorMessage.cssClass = 'error-text'
      this.errorMessage.message = ''
      this.errorMessage.linkText = ''
      this.errorMessage.before = ''
      this.errorMessage.after = ''
    },
    formatMessageWithLink(text) {
      const linkPattern = /{([^}]+)}/g
      const beforePattern = /([^{]+){/g
      const afterPattern = /}([^}]+)/g
      const beforeText = beforePattern.exec(text)
      const linkText = linkPattern.exec(text)
      const afterText = afterPattern.exec(text)

      this.errorMessage.message = ''
      this.errorMessage.before = beforeText !== null ? beforeText[1] : ''
      this.errorMessage.linkText = linkText !== null ? linkText[1] : ''
      this.errorMessage.after = afterText !== null ? afterText[1] : ''
    }
  }
}
</script>
